<template>
  <div class="orgTag app-container">
    <div class="global-header-wrap">
      <h3>{{ $t("org.orgTag") }}</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="orgTag-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchEvn" />
          </div>
          <div class="orgTag-header-right">
            <button
              class="global-button-style"
              @click="$store.commit('windowHandle', 'addPopup')"
            >
              {{ $t("org.addTag") }}
            </button>
            <button class="global-button-style">
              {{ $t("org.exportTag") }}
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <transition name="fade">
      <addComponent
        v-if="addPopup"
        :title="$t('org.addTag')"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvn="addEvn"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import addComponent from "@/components/addPopup";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    addComponent,
    appTable,
    pagination
  },
  computed: {
    ...mapGetters(["addPopup"]),
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: this.$t("org.tagName"),
          placeholder: this.$t("placeholder.tagName")
        }
      ];
      return ruleProps;
    },
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        ]
      };
      return rules;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("org.tagName")
        },
        {
          prop: "orgs",
          label: this.$t("org.orgCount")
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          btn: [this.$t("commonMsg.checkDetails"), this.$t("commonMsg.del")]
        }
      ];
      return tableProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      ruleForm: {
        name: ""
      },
      params: {
        limit: 20,
        offset: 0
      },
      tableData: [],
      total: 0,
      year: 0
    };
  },
  methods: {
    getList() {
      this.$http.getTagList(this.params).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.count;
      });
    },

    toDetails(data) {
      this.$router.push({
        name: "orgTagDetails",
        query: { id: data.row.id, name: data.row.name }
      });
    },

    del(data) {
      this.$http.delTag(data.row.id).then(res => {
        this.tableData.splice(data.$index, 1);
      });
    },

    addEvn(data) {
      this.$http.addTag(data).then(res => {
        this.getList();
        this.$store.commit("windowHandle");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.orgTag {
  .orgTag-btn {
    text-align: right;
    padding: 10px;
  }
  .orgTag-pagination {
    padding: 10px;
    text-align: right;
  }
}
</style>
